import axios from "../http";

export function useProduct() {
  const getProducts = (params) => axios.get('/api/products', {params});
  const getProduct = id => axios.get(`/api/products/${id}`);
  const create = (params) => axios.post('/api/products', params);
  const update = (id, params) => axios.post(`/api/products/${id}`, params);
  const remove = (id) => axios.delete(`/api/products/${id}`);
  const getTypes = () => {
    return [
      {
        value: 'DIGITAL',
        label: 'Digital product',
      },
      {
        value: 'PHYSICAL',
        label: 'Physical product',
      },
    ]
  }

  return {
    getProducts,
    getProduct,
    create,
    update,
    remove,
    getTypes,
  }
}
